var r=function(r){var n=!r||r instanceof Array&&!r.length?[]:r,a=n instanceof Array?n:[n];return Array.from(new Set(a))};export{r as sanitizeErrors};
